#import "./AddressFull.graphql"
#import "./FakturoidDataFull.graphql"
#import "./GoPayDataFull.graphql"
#import "./TaxedPriceFull.graphql"

fragment PublicSubscriptionFull on PublicSubscription {
  b2cDetailId
  status
  kind
  customerId
  successorB2cDetailId
  email
  phoneNumber
  lastDispatchDate
  nextDispatchDate
  billingAddress {
    ...AddressFull
  }
  deliveryAddress {
    ...AddressFull
  }
  fakturoidData {
    ...FakturoidDataFull
  }
  goPayData {
    ...GoPayDataFull
  }
  previousGoPayData {
    ...GoPayDataFull
  }
  cancelledAt
  cancelRequestedAt
  nextPaymentDate
  startsAt
  createdAt
  endsAt
  variant
  selection
  size
  frequency
  recurringFakturoidData {
    ...FakturoidDataFull
  }
  currency
  price {
    ...TaxedPriceFull
  }
}
